module.exports = __webpack_public_path__ + "static/media/view2.6ca73dc2.jpg";